import React from "react";
import { Trans } from "@lingui/macro";
import { Button } from "components/UI/Button/Button";
import { WithTitle } from "components/UI/WithTitle/withTitle";

export type typeDSalesActions = {
  onClickExport: () => void;
};

export const DSalesActions: React.FC<typeDSalesActions> = ({
  onClickExport,
}) => {
  return (
    <>
      <WithTitle
        titleText={
          <Trans>
            Export of all sales from the table, taking into account the applied
            filters
          </Trans>
        }
        component={
          <Button
            secondary={true}
            buttonClassName="flex-initial"
            type="button"
            label={<Trans>Export</Trans>}
            onClick={onClickExport}
          />
        }
      />
    </>
  );
};
